import { useEffect } from "react"
export function useDebouncedEffect(delay, effect, triggerParams) {
    useEffect(() => {
      const timeout = setTimeout(effect, delay)
      return () => clearTimeout(timeout)
    }, triggerParams)
}